export default __webpack_public_path__ + "static/media/icon-select-off.19ab3f78.svg";